import { sellerOpportunities } from '@backmarket/http-api'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'

const DEFAULT_VALUE = {
  filterMarket: [],
  filterCategory: [],
  canIncreasePageSize: false,
} as sellerOpportunities.GetPricingOpportunitiesMetadata

export function useMetadata() {
  const { data: metadata } = useHttpFetch(
    sellerOpportunities.getPricingOpportunitiesMetadata,
    { default: () => DEFAULT_VALUE },
  )

  return {
    metadata,
  }
}
